import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { StyledCheckbox } from "commonComponents/FormElement/Checkbox/CheckboxStyled";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  NOTIFICATION_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
} from "../../../../globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch } from "react-redux";
import {
  Container,
  Header,
  AddEmailInput,
  PlayerAssistance,
  ActionBtn,
} from "pages/Messages/Notifications/AddEmail/AddEmailStyled";
import { CircleBtn, PopUpContainer } from "assets/css/globle";
import AddIcon from "assets/svgIcons/AddIconWithCircle";
import ExclamationMark from "assets/svgIcons/MsgNotificationIcons/ExclamationMarkIcon";
import CarFaultIcon from "assets/svgIcons/MsgNotificationIcons/CarFaultIcon";
import BatteryIcon from "assets/svgIcons/MsgNotificationIcons/LowBatteryIcon";
import MaxHolesIcon from "assets/svgIcons/MsgNotificationIcons/MaxHolesIcon";
import { useTranslation } from "react-i18next";
import { isUserBasic, isUserReadOnly, isUserAdminOrSupport } from "constant";
import { useSelector } from "react-redux";
import { Modal, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import { validateEmail } from "_helperFunctions/validateEmail";
const AddEmail = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const { getUserRole } = useSelector((state) => state.commonReducers) || [];
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const [emailEnableDisable, setEmailEnableDisable] = React.useState(false);
  const [enableEmailField, setEnableEmailField] = React.useState(false);
  const [alertChecked, setAlertChecked] = React.useState(false);
  const [checkedAPlayer, setCheckedAPlayer] = React.useState(false);
  const [checkedAAction, setCheckedAAction] = React.useState(false);
  const [checkedACar, setCheckedACar] = React.useState(false);
  const [checkedALow, setCheckedALow] = React.useState(false);
  const [checkedAMax, setCheckedAMax] = React.useState(false);
  const [checkedAFirstHoleStarted, setCheckedAFirstHoleStarted] = React.useState(false);
  const [isValid, setIsValid] = useState("");

  const {
    editButton,
    notificatioEmail,
    notificationPlayer,
    notificationActionZone,
    notificationCarFault,
    notificationLowBattery,
    notificationMaxHoles,
    notificationFirstHoleStarted,
    watch,
    notificatioAddEmailButton,
    notificationAlertSOS,
    enableEmailOnEdit,
    alertEnable,
    disableCross,
    editButtonId,
    saveEnable,
  } = useHookstate(NOTIFICATION_GLOBAL_STATES);
  //  input email state
  const [inputEmailOnAddEmail, setInputEmailOnAddEmail] = React.useState("");
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "calc(100% -  40px)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };
  // functions for toggle switch
 
  // function to handel clear button
  const handelClearButton = () => {
    setCheckedAPlayer(false);
    setCheckedAAction(false);
    setCheckedACar(false);
    setCheckedALow(false);
    setCheckedAMax(false);
    setCheckedAFirstHoleStarted(false);
    setAlertChecked(false);
    setEmailEnableDisable(true);
    setInputEmailOnAddEmail("");
    editButton.set(null);
    notificatioEmail.set("");
    notificationPlayer.set(false);
    notificationActionZone.set(false);
    notificationCarFault.set(false);
    notificationLowBattery.set(false);
    notificationMaxHoles.set(false);
    watch.set(null);
    notificatioAddEmailButton.set(null);
    notificationAlertSOS.set(false);
    setIsValid("");
    disableCross.set(true);
    editButtonId.set(0);
  };
  // function to handel save button

  const resetUsernameData = () => {
    saveEnable.set(false);
    watch.set(watch.get() + 1);
    disableCross.set(true);
    notificatioAddEmailButton.set(false);
    notificatioEmail.set("");
    editButtonId.set(0);
    setIsValid("");
    handleClose();
  };

  const handleSaveButton = () => {
    saveEnable.set(false);
    let payload = {
      Id: 93,
      SiteId: siteId.get(),
      CreateDateInUtc: "2022-07-27T11:27:10.617",
      UpdateDateInUtc: "2022-07-27T11:27:10.617Z",
      UpdatedBy: "VisageMobileProgramming",
      Email: inputEmailOnAddEmail,
      AlertsEnabled: alertChecked,
      AlertActionZone: checkedAAction,
      AlertCarFault: checkedACar,
      AlertLowBattery: checkedALow,
      AlertMaximumHoles: checkedAMax,
      AlertFirstHoleStarted: checkedAFirstHoleStarted,
      AlertSOS: checkedAPlayer,
    };
    if (editButton.get()) {
      payload.Id = editButton.get();
      dispatch(COMMON_SERVICES.updateEmailServices(payload, siteId.get()))
        .then(() => {
          dispatch(COMMON_SERVICES.getAlertMessageServices(siteId.get()));
        })
        .then(() => handelClearButton());
    } else {
      dispatch(COMMON_SERVICES.setSaveEmailApiCall(payload, siteId.get()))
        .then(() => {
          dispatch(COMMON_SERVICES.getAlertMessageServices(siteId.get()));
        })
        .then(() => {
          saveEnable.set(false);
          handelClearButton();
        });
    }
  };

  // data comming from global store
  const handelEditAction = () => {
    setCheckedAPlayer(notificationAlertSOS.get());
    setCheckedAAction(notificationActionZone.get());
    setCheckedACar(notificationCarFault.get());
    setCheckedALow(notificationLowBattery.get());
    setCheckedAMax(notificationMaxHoles.get());
    setCheckedAFirstHoleStarted(notificationFirstHoleStarted.get());
    setAlertChecked(alertEnable.get());
    setInputEmailOnAddEmail(notificatioEmail.get());
    setEmailEnableDisable(notificatioAddEmailButton.get());
    setEnableEmailField(enableEmailOnEdit.get());
  };

  useEffect(() => {
    handelEditAction();
  }, [editButton.get(), notificatioAddEmailButton.get()]);

  useEffect(() => {
    handelEditAction();
  }, [watch.get()]);

  const bgcolor = emailEnableDisable
    ? "var(--theme-background)"
    : "var(--input-background)";
  const color = emailEnableDisable ? "#fff" : "#000";
  const handleInputChange = (event) => {
    setInputEmailOnAddEmail(event.target.value);
    if (inputEmailOnAddEmail === "") {
      saveEnable.set(false);
    }
    if (validateEmail(event.target.value)) {
      setIsValid("Email is valid");
      saveEnable.set(true);
    } else {
      setIsValid(<p style={{ color: "red" }}>{t("Email_is_not_valid")}</p>);
      saveEnable.set(false);
    }
  };

  const canEditCarFault = isUserAdminOrSupport(getUserRole && getUserRole?.Role);

  const emailAdd = () => {
    if (emailEnableDisable) {
      setEmailEnableDisable(false);
      setInputEmailOnAddEmail(inputEmailOnAddEmail);
      setAlertChecked(false);
      setCheckedAPlayer(false);
      setCheckedAAction(false);
      setCheckedACar(false);
      setCheckedALow(false);
      setCheckedAMax(false);
      setInputEmailOnAddEmail("");
      setCheckedAFirstHoleStarted(false);
      disableCross.set(true);
      editButtonId.set(0);
    } else {
      setEmailEnableDisable(true);
      setInputEmailOnAddEmail("");
      setAlertChecked(true);
      setCheckedAPlayer(true);
      setCheckedAAction(true);
      if (canEditCarFault) setCheckedACar(true);
      setCheckedALow(true);
      setCheckedAMax(true);
      setCheckedAFirstHoleStarted(true);
    }
  };
  return (
    <Container>
      <div>
        <Header>
          <h3>
            {t("Email")}
            <Tooltip
              title={
                <><p>Send Text via Email,</p> <p>Verizon: 9495551212@vtext.com,</p><p>ATT: 9495551212@mms.att.net</p></>
              }
              arrow
            >
              <span>
                <HelpOutlineIcon />
              </span>
            </Tooltip>
          </h3>

          <Tooltip title={t("Add_email")} arrow>
            <CircleBtn
              disabled={
                isUserBasic(getUserRole && getUserRole?.Role) ||
                isUserReadOnly(getUserRole && getUserRole?.Role)
              }
              onClick={() => emailAdd()}
              style={{
                backgroundColor: bgcolor,
                color: color,
              }}
            >
              <AddIcon color={emailEnableDisable ? "#fff" : "#000"} />
              {t("Add_email")}
            </CircleBtn>
          </Tooltip>
        </Header>
        <AddEmailInput>
          <input
            value={inputEmailOnAddEmail}
            onChange={(e) => handleInputChange(e)}
            disabled={!emailEnableDisable}
            placeholder={t("Enter_your_email")}
          />
          <p className="p-15 pb-0">
            <small>{isValid}</small>
          </p>
        </AddEmailInput>
      </div>
      <div>
        {emailEnableDisable ? (
          <Tooltip title={t("Turn_on/off_email_alerts")} arrow>
            <StyledCheckbox className="checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={alertChecked}
                    onChange={(e) => {
                      saveEnable.set(true);
                      setAlertChecked(e.target.checked);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                    checkedIcon={<CheckIcon />}
                    icon={<UnCheckIcon />}
                  />
                }
                label={t("Alerts_Enabled")}
              />
            </StyledCheckbox>
          </Tooltip>
        ) : (
          ""
        )}
        {emailEnableDisable ? (
          <PlayerAssistance className="player-assistance">
            <Tooltip title={t("Turn_on/off_Assistance_alerts")} arrow>
              <button
                className={
                  checkedAPlayer === true
                    ? "active assistance-btn"
                    : "assistance-btn"
                }
                checked={checkedAPlayer}
                onClick={(e) => {
                  saveEnable.set(true);
                  setCheckedAPlayer(!checkedAPlayer);
                }}
                inputProps={{ "aria-label": "controlled" }}
              >
                {t("Player_Assistance")}
              </button>
            </Tooltip>
            <div>
              <Tooltip title={t("Select_all")} arrow>
                <button
                  className={
                    checkedAAction && checkedACar && checkedALow && checkedAMax && checkedAFirstHoleStarted
                      ? "active text-center"
                      : "text-center"
                  }
                  onClick={() => {
                    saveEnable.set(true);
                    setCheckedAAction(true);
                    if (canEditCarFault) setCheckedACar(true);
                    setCheckedALow(true);
                    setCheckedAMax(true);
                    setCheckedAFirstHoleStarted(true);
                  }}
                >
                  {t("Select_all")}
                </button>
              </Tooltip>
              <Tooltip title={t("Deselect_all")} arrow>
                <button
                  className={
                    !checkedAAction &&
                      !checkedACar &&
                      !checkedALow &&
                      !checkedAMax && 
                      !checkedAFirstHoleStarted
                      ? "active text-center"
                      : "text-center"
                  }
                  onClick={() => {
                    saveEnable.set(true);
                    setCheckedAAction(false);
                    if (canEditCarFault) setCheckedACar(false);
                    setCheckedALow(false);
                    setCheckedAMax(false);
                    setCheckedAFirstHoleStarted(false);
                  }}
                >
                  {t("Deselect_all")}
                </button>
              </Tooltip>
              <Tooltip title={t("Turn_on/off_action_zone_alerts")} arrow>
                <button
                  className={checkedAAction === true ? "active" : ""}
                  checked={checkedAAction}
                  onClick={(e) => {
                    saveEnable.set(true);
                    setCheckedAAction(!checkedAAction);
                  }}
                >
                  <ExclamationMark />
                  {t("Action_Zones")}
                </button>
              </Tooltip>
              <Tooltip
                title={
                  canEditCarFault
                    ? t("Turn_on/off_car_fault_alerts")
                    : t("Only_admin_or_support_can_modify_this")
                }
                arrow
              >
                <span>
                  <button
                    className={checkedACar === true ? "active" : ""}
                    disabled={!canEditCarFault}
                    checked={checkedACar}
                    onClick={(e) => {
                      if (!canEditCarFault) return;
                      saveEnable.set(true);
                      setCheckedACar(!checkedACar);
                    }}
                  >
                    <CarFaultIcon />
                    {t("Car_Fault")}
                  </button>
                </span>
              </Tooltip>
              <Tooltip title={t("Turn_on/off_low_battery_alerts")} arrow>
                <button
                  className={checkedALow === true ? "active" : ""}
                  checked={checkedALow}
                  onClick={(e) => {
                    saveEnable.set(true);
                    setCheckedALow(!checkedALow);
                  }}
                >
                  <BatteryIcon />
                  {t("Low_Battery")}
                </button>
              </Tooltip>
              <Tooltip title={t("Turn_on/off_max_holes_alerts")} arrow>
                <button
                  className={checkedAMax === true ? "active" : ""}
                  checked={checkedAMax}
                  onClick={(e) => {
                    saveEnable.set(true);
                    setCheckedAMax(!checkedAMax);
                  }}
                >
                  <MaxHolesIcon />
                  {t("Max_Holes")}
                </button>
              </Tooltip>
              <Tooltip title={t("Turn_on/off_member_playing_alerts")} arrow>
                <button
                  className={checkedAFirstHoleStarted === true ? "active" : ""}
                  checked={checkedAFirstHoleStarted}
                  onClick={(e) => {
                    saveEnable.set(true);
                    setCheckedAFirstHoleStarted(!checkedAFirstHoleStarted);
                  }}
                >
                  <MaxHolesIcon />
                  {t("Member_Playing")}
                </button>
              </Tooltip>
            </div>
          </PlayerAssistance>
        ) : (
          ""
        )}
        {emailEnableDisable ? (
          <ActionBtn>
            <Tooltip title={t("Save")} arrow>
              <CircleBtn
                disabled={
                  isUserBasic(getUserRole && getUserRole?.Role) ||
                  isUserReadOnly(getUserRole && getUserRole?.Role) ||
                  saveEnable.get() === false ||
                  inputEmailOnAddEmail === ""
                }
                className={
                  isUserBasic(getUserRole && getUserRole?.Role) ||
                    isUserReadOnly(getUserRole && getUserRole?.Role) ||
                    saveEnable.get() === false ||
                    inputEmailOnAddEmail === ""
                    ? "disabled"
                    : "active"
                }
                onClick={handleSaveButton}
              >
                {t("Save")}
              </CircleBtn>
            </Tooltip>
            <Tooltip title={t("Cancel")} arrow>
              <CircleBtn
                disabled={
                  isUserBasic(getUserRole && getUserRole?.Role) ||
                  isUserReadOnly(getUserRole && getUserRole?.Role)
                }
                onClick={handleOpen}
              >
                {t("Cancel")}
              </CircleBtn>
            </Tooltip>
          </ActionBtn>
        ) : (
          ""
        )}
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Discard_changes")}?</p>
            <div className="action-btn">
              <button onClick={() => resetUsernameData()} className="primary">
                {t("Yes")}
              </button>
              <button onClick={() => handleClose()}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddEmail;
